<template>
    <div class="feature-section-container">
        <div class="section-header">
            <h3>おすすめポイント</h3>
        </div>
        <div class="section-content">
            <div class="feature-item">
                <div class="feature-title-wrapper">
                    <span class="icon rank-1-icon">1</span>
                    <h4 class="feature-title"><span class="bold-red">最大91%OFF！</span>業界最安値クラスの料金</h4>
                </div>
            </div>

            <div class="feature-item point2">
                <div class="feature-title-wrapper">
                    <span class="icon">2</span>
                    <h4 class="feature-title"><span class="bold-red">最短即日</span>対応可能！</h4>
                </div>
            </div>

            <div class="feature-item point3 no-border">
                <div class="feature-title-wrapper">
                    <span class="icon">3</span>
                    <h4 class="feature-title">工事・商品の<span class="bold-red">１０年無料保証付き</span></h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FeatureSection',
    data() {
        return {
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth() + 1
        };
    }
};
</script>

<style scoped>
.feature-section-container {
    background-color: white;
    border: 1px solid gray;
    margin: 20px;
    margin-top: 0;
}

.section-header {
    background-color: #3f51b5;
    color: white;
    padding: 20px;
    margin-bottom: 20px;
}

.section-header h3 {
    margin: 0;
    font-size: 22px;
}

.feature-item {
    margin-bottom: 20px;
    border-bottom: 3px dotted gray;
}

.feature-item.no-border {
    border-bottom: none;
    margin-bottom: 0;
}

.annotation-txt {
    margin: 0;
    padding: 0;
    text-align: right;
    margin-bottom: 5px;
}

.feature-title-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.point-3 {
    width: 100%;
}

.icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background-color: #ffc107;
    color: white;
    font-weight: bold;
    border-radius: 50%;
    margin-right: 10px;
}

.feature-title {
    font-size: 22px;
    font-weight: bold;
    color: #333;
    margin: 0;
}

.feature-description {
    color: #555;
    line-height: 1.5;
    text-align: left;
    padding: 10px;
    padding-top: 0;
}

.image-box {
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 20px;
}

.image-box.yellow-border {
    border: 2px solid #ffc107;
}

.feature-image {
    width: 100%;
    height: auto;
    display: block;
}

.section-content {
    padding: 15px;
    padding-top: 0;
    padding-bottom: 0;
}

.feature-item img {
    width: 100%;
    margin-bottom: 20px;
}

.point3 img {
    width: 80%;
    margin-top: 10px;
}

.point2 img,
.point4 img {
    width: 90%;
    margin-top: 10px;
    border-radius: 20px;
}

.mitumori {
    display: flex;
    overflow-x: auto;
    gap: 16px;
    padding: 10px 0;
    scroll-snap-type: x mandatory;
    margin-bottom: 15px;
}

.mitumori::-webkit-scrollbar {
    height: 6px;
}

.mitumori::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
}

.mitumori-card {
    flex: 0 0 80%;
    background: #fff;
    border: 1px solid #ddd;
    padding: 10px;
    scroll-snap-align: start;
    text-align: center;
}

.mitumori-card img {
    width: 100%;
    border-radius: 4px;
    margin-top: 8px;
}

.mitumori-label {
    font-weight: bold;
    font-size: 20px;
    padding: 10px;
    margin: 0;
    border-radius: 20px;
    display: inline-block;
}

.mitumori-label.other {
    background: gray;
    color: #fff;
}

.mitumori-label.ours {
    background: #3f51b5;
    color: #fff;
}

.total-cost {
    padding: 15px;
    background-color: #f1efef;
}

.total-cost2 {
    padding: 15px;
    background-color: #E91E63;
    font-weight: bold;
    color: #fff;
}

.scroll-text {
    text-align: right;
    margin-top: 0;
    margin-right: 15px;
    margin-bottom: 0;
    padding-top: 10px;
    font-size: 12px;
}

.feature-title {
    text-align: left;
}

.review-img {
    margin-bottom: 0;
    padding: 0;
}

@keyframes blinking {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.blink {
    animation: blinking 1s ease-in-out infinite alternate;
}

/* ====== 追加: アコーディオン専用 ====== */
.accordion {
    border: 1px solid #ddd;
    border-radius: 8px;
    margin: 10px 0;
    overflow: hidden;
    background: #fff;
}

.accordion>summary {
    cursor: pointer;
    padding: 12px 14px;
    font-weight: 700;
    color: gray;
    list-style: none;
    position: relative;
    outline: none;
}

.accordion summary::-webkit-details-marker {
    display: none;
}

.accordion>summary::after {
    content: '＋';
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
}

.accordion[open]>summary {
    border-bottom: 1px dashed #ddd;
}

.accordion[open]>summary::after {
    content: '－';
}

.accordion-content {
    padding: 12px 14px;
    color: #555;
    line-height: 1.6;
    text-align: left;
}

.warranty-list {
    margin: 8px 0 0 0;
    padding: 0;
    list-style: none;
}

.warranty-list li {
    margin: 4px 0;
}

/* ====== 追加ここまで ====== */

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .section-content {
        padding: 5px;
    }

    .section-header h3 {
        font-size: 1.2rem;
        padding: 10px;
    }

    .section-header {
        padding: 0;
    }

    .icon {
        width: 20px;
        height: 20px;
        font-size: 1rem;
    }

    .feature-title {
        font-size: 1.2rem;
    }

    .accordion-content {
        font-size: 0.8rem;
    }

    .feature-description {
        font-size: 1rem;
    }

    .mitumori-label {
        font-size: 0.9rem;
        padding: 10px 15px;
    }

    .total-cost,
    .total-cost2 {
        font-size: 1rem;
    }

    .scroll-text {
        font-size: 0.7rem;
    }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {
    .feature-section-container {
        margin: 5px;
    }

    .icon {
        width: 30px;
        height: 30px;
        font-size: 1.2rem;
    }

    .rank-1-icon {
        width: 40px;
    }

    .feature-title {
        font-size: 1.3rem;
    }

    .feature-description {
        font-size: 0.9rem;
    }

    .annotation-txt {
        font-size: 0.6rem;
    }
}
</style>
